import './About.css';
import Gears from "./steampunk-gear-cog-wheels.svg";

import React, {Component} from 'react';

class About extends Component {
    render() {
        return(
            <div className="about-wrap">
                <div className="heading" >Creating Internet and World Wide Web Experiences Since 1999</div>
                <div className="content" >UserX engineering is all about creating innovative and engaging experiences for the Internet and World Wide Web. What do <em>you</em> want to experience?</div>
                <div className="gear-svg-wrap">
                    <img  src={Gears} />
                </div>
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/about/index.js